// Embedded sensor
export const SENSOR_TYPE_DOOR = "17";
export const SENSOR_TYPE_TEMP_HUMIDITY = "18";
export const SENSOR_TYPE_FIRE = "19";
export const SENSOR_TYPE_SOS = "34";

export const SENSOR_TYPE_SPOT = "SPOT";
export const SENSOR_TYPE_GATE = "GATE";
export const SENSOR_TYPE_GATE_3D = "GATE_3D";
